module.exports = __webpack_public_path__ + "static/img/sm_9.3cac53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_9.png
// module id = kAVF
// module chunks = 0